import { actionTypes } from "../actions/channels";

const variable = (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_CHANNEL_TYPES:
      return action.payload;
    default:
      return state;
  }
};

export default variable;